<template>
  <div class="rounded-primary border border-light-green p-2 flex justify-center flex-col">
    <slot />
  </div>
</template>
